'use client'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/utils/styles/cn'
import { KeyboardEvent } from 'react'

export type SupportLineItemProps = {
    icon: React.ReactNode
    title: string
    onClick: () => void
    description?: string
    className?: string
    iconClassName?: string
}

export function SupportLineItem({ icon, title, description, onClick, className, iconClassName }: SupportLineItemProps) {
    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick()
        }
    }

    return (
        <div
            className={cn(
                'flex flex-row items-center justify-between p-3 rounded-md cursor-pointer transition-colors',
                'hover:bg-muted/50 active:bg-muted',
                className
            )}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
        >
            <div className="flex flex-row items-center gap-3">
                <div
                    className={cn(
                        'flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary aspect-square',
                        iconClassName
                    )}
                >
                    {icon}
                </div>
                <div>
                    <p className="text-sm font-medium">{title}</p>
                    {description && <p className="text-xs text-muted-foreground">{description}</p>}
                </div>
            </div>
            <ChevronRight className="w-4 h-4 text-muted-foreground" />
        </div>
    )
}
